import $ from 'jquery'
import { Fancybox } from '@fancyapps/ui'
import { Modal } from 'bootstrap'

let piModalInstance

Fancybox.bind('[data-fancybox="product-gallery"]', {
  Thumbs: {
    type: 'classic',
  },
})

$('.product-info .product-info__closer').on('click', function () {
  $(this).closest('.product-info').addClass('closed dont-open-on-scroll')
})

$('.product-info').on('click', function () {
  if (window.matchMedia('(max-width: 991.98px)').matches && piModalInstance) {
    piModalInstance.show()
    return
  }
})

$(document).on('click', '.product-info.closed', function (e) {
  if (window.matchMedia('(max-width: 991.98px)').matches && piModalInstance) {
    return
  }

  if ($(e.target).hasClass('product-info__closer')) {
    return
  }

  $(this).removeClass('closed')
})

const modalEl = document.querySelector('.pi-modal')
if (modalEl) {
  piModalInstance = Modal.getOrCreateInstance(modalEl)
}

const infoEl = document.querySelector('.product-info')

if (infoEl) {
  window.addEventListener('scroll', function () {
    if (
      this.scrollY >= 200 &&
      !infoEl.classList.contains('dont-open-on-scroll')
    ) {
      infoEl.classList.remove('closed')
    }
  })
}
